import 'css-chunksrc/client/scenes/workloads/wbs/milestone/styles.scss';export default {
  "milestone": "_milestone_nzsbz_1",
  "contextualMenu": "_contextualMenu_nzsbz_7",
  "milestoneDetails": "_milestoneDetails_nzsbz_11",
  "name": "_name_nzsbz_18",
  "icon": "_icon_nzsbz_32",
  "taskAdvancement": "_taskAdvancement_nzsbz_36",
  "taskAdvancementWrapper": "_taskAdvancementWrapper_nzsbz_42",
  "removeIcon": "_removeIcon_nzsbz_55",
  "status": "_status_nzsbz_59",
  "allocations": "_allocations_nzsbz_67",
  "text": "_text_nzsbz_74",
  "tick": "_tick_nzsbz_80",
  "completed": "_completed_nzsbz_87",
  "displayContextualMenu": "_displayContextualMenu_nzsbz_98",
  "placeholder": "_placeholder_nzsbz_102",
  "milestoneCompletion": "_milestoneCompletion_nzsbz_107",
  "completionDate": "_completionDate_nzsbz_114",
  "constrained": "_constrained_nzsbz_120",
  "constraintsPopup": "_constraintsPopup_nzsbz_124"
};